import { effect, inject, Injectable, signal } from '@angular/core';
import { DocumentsPersistency } from '../../api/compiledDocumentPersistency';
import { CompilingFormService } from '../compiling/compiling-form.service';

@Injectable()
export class CompiledService {
  private readonly documentApiService = inject(DocumentsPersistency);
  private readonly forms = inject(CompilingFormService);

  private readonly _formValue = signal<{ [key: string]: unknown } | undefined>(
    undefined,
  );

  constructor() {
    effect(() => {
      const ready = this.forms.ready();
      if (!ready) return;

      const form = this._formValue();
      if (!form) return;

      this.forms.form.patchValue(form);
      this.forms.form.disable();
    });
  }
}
